const IN_PRODUCTION = process.env.NODE_ENV === 'production'

const productionEnvConfig = {
  apiKey: 'AIzaSyAbZYjhD0HjpkTjs3iijOgTPForzz_K2YY',
  authDomain: 'match-central.firebaseapp.com',
  projectId: 'match-central',
  storageBucket: 'match-central.appspot.com',
  messagingSenderId: '256143048806',
  appId: '1:256143048806:web:766d3f5c7fedc91e522da7',
}

const developmentEnvConfig = {
  apiKey: 'AIzaSyB9JEDliHiuqxvxGefyuVnJIefuFlpIG-4',
  authDomain: 'match-central-test.firebaseapp.com',
  projectId: 'match-central-test',
  storageBucket: 'match-central-test.appspot.com',
  messagingSenderId: '4677540373',
  appId: '1:4677540373:web:6bbb121485c4a50ce24c1c',
}

export const firebaseConfig = IN_PRODUCTION ? productionEnvConfig : developmentEnvConfig

export const apiBaseUrl = IN_PRODUCTION
  ? 'https://match-central-api.herokuapp.com'
  : 'http://localhost:5000'
